<script setup lang="ts">
import { useProfileFeed } from '~~/src/composables/query/useProfileFeed'
import type { ElementalTypeEnum } from '~~/src/types/elemental'

const props = defineProps<{
  type: ElementalTypeEnum
}>()
defineOptions({ name: 'ListLoader' })

const { firebaseUser } = useFirebaseAuth()
const { data, refetch, isLoading, error, isError } = useProfileFeed(props.type, firebaseUser.value?.uid as string, {
  mode: 'saved',
  order_by: 'name',
  elemental_type_id: props.type,
  size: 0,
})
</script>

<template>
  <slot :lists="data" :error="error" :is-error="isError" :is-loading="isLoading" :refetch="refetch" />
</template>
